import React from "react";
import { useNavigate } from "react-router-dom";

import Div100vh from "react-div-100vh";
import Lottie from "lottie-react";

export default function NotFoundScreen() {
  const navigate = useNavigate();

  return (
    <Div100vh className="flex flex-col justify-evenly items-center text-lg">
      {/* <Lottie className="h-[60%]" animationData={load} loop={true}/> */}
      <div className="flex flex-col gap-8">
        <span className="flex items-center justify-center text-[#1987fb] text-2xl font-semibold">
          Sorry...🫠
        </span>
        <div className="flex flex-col">
          <span className="flex items-center justify-center text-[#eeeeee]">
            This is taking unusually long.
          </span>
          <span className="flex items-center justify-center text-[#999999] font-medium">
            Let us get back shortly!
          </span>
        </div>
      </div>
      <div className="flex flex-col gap-4">
        <button
          className="p-4 rounded-full border border-[#1987fb] text-[#1987fb] text-sm font-medium"
          onClick={() => navigate("/")}
        >
          Take me home
        </button>
        <span className="text-[#999999] text-base">
          error: 404 page not found
        </span>
      </div>
    </Div100vh>
  );
}
